module.exports = __webpack_public_path__ + "static/media/hakutsuru.2d3dfc20.png";